import React from "react";
import { FileCard } from "./FileCard";
import { useFileUploadItem } from "../hooks/useFileUploadItem";
import { UploadedFile } from "../types/UploadedFile.type";
import { SharedFileItemProps } from "../types/ShareProps.types";

interface FileItemProps extends SharedFileItemProps {
	file: UploadedFile;
}

/**
 * The item used to control an uploading/uploaded file
 * @param param0
 * @returns
 */
export const FileItem: React.FC<FileItemProps> = ({
	file,
	extraData,
	isPreview,
	onRemove,
	onUploadComplete,
	onUploadStart,
	onUploadError,
}) => {
	const { error, isUploading, progress, cancelUpload, retryUpload } =
		useFileUploadItem({
			file,
			extraData,
			onComplete: onUploadComplete,
			onStart: onUploadStart,
			onError: onUploadError,
		});

	const cancelFileUpload = () => {
		if (!file.uploadId) {
			return;
		}

		cancelUpload(file.uploadId);
		onRemove(file.uploadId);
	};

	const onDelete = () => {
		if (!file.id && !file.uploadId) {
			return;
		}

		onRemove(file.id ?? file.uploadId);
	};

	return (
		<FileCard
			file={file}
			progress={progress}
			isUploading={isUploading}
			error={error}
			isPreview={isPreview}
			onCancel={cancelFileUpload}
			onDelete={onDelete}
			onRetry={retryUpload}
		/>
	);
};
